import { z } from 'zod';
/**
 * Eigene Domain (Verwaltung › Verein › Eigene Domain) — siehe docs/custom-domain.md
 * für den vollständigen Ablauf. Der Statusfluss ist bewusst ein Dreischritt mit
 * einem manuellen Freigabe- (Plattformadmin) und Konfigurationsschritt (Coolify):
 * die App selbst spricht Coolify nie an, sie kennt Coolify überhaupt nicht
 * (siehe packages/config/src/env.ts).
 */
export const CUSTOM_DOMAIN_STATUSES = ['none', 'pending_approval', 'approved', 'active', 'rejected'];
export const CUSTOM_DOMAIN_STATUS_LABELS = {
    none: 'Keine Domain hinterlegt',
    pending_approval: 'Warte auf Freigabe',
    approved: 'Freigegeben — Coolify-Eintrag steht noch aus',
    active: 'Aktiv',
    rejected: 'Abgelehnt',
};
/** Simple hostname validation (labels of letters/digits/hyphens, at least one
 * dot) — deliberately permissive, real validation happens by actually trying
 * to reach the domain (`verify`), not by over-fitting a regex to every valid
 * DNS edge case. */
export const domainHostname = z
    .string()
    .trim()
    .toLowerCase()
    .max(255)
    .regex(/^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?(\.[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)+$/, 'Ungültiger Domainname (z. B. verein.beispiel.de)');
export const setCustomDomainRequest = z.object({
    enabled: z.boolean(),
    domain: z
        .union([domainHostname, z.literal('')])
        .optional()
        .transform((v) => (v ? v : undefined)),
});
/** Step 1's "DNS prüfen" — checks whatever the club currently has typed, not
 * necessarily the already-saved value (so they can iterate before hitting
 * "Speichern"). */
export const checkDnsRequest = z.object({ domain: domainHostname });
export const rejectDomainRequest = z.object({
    reason: z.string().trim().max(500).optional(),
});
//# sourceMappingURL=custom-domain.js.map